import {
  login,
  logout,
  getMenu,
  updatePassword,
  publicUpdatePassword,
  updateHeadImg,
  changeLanguage,
  getUserInfo,
  getPermisson,
  getStatement,
  sendEmail,
  forgetPassword,
  sendMessage,
  checkPass,
  sendEmailForChangePwd,
  publicSendEmailForChangePwd,
  getCheckCode,
  submitChckeCode,
  incrScannedTimes,
  getRegisterCode,
  register,
  getCompanyList,
  getCustomerCompanyList,
  updateSession,
  checkAccount,
  activate,
  reActivate,
  updateUserInfo,
  getDegretionInfo,
  writtenOff,
  checkPassword,
  publicCheckPassword,
  checkNewPassword,
  getCustomerCompanyData,
  unlockEmailWhetherSent
} from '@/axios/api/login'
import { getToken, setToken, removeToken } from '@/utils/token'
import Track from '@/utils/web-tracking'
import { Message } from 'element-ui'
import axios from 'axios'

const SET_TOKEN = 'SET_TOKEN'
const SET_MENU = 'SET_MENU'
const SET_AUTH = 'SET_AUTH'
const SET_USER_INFO = 'SET_USER_INFO'
const UPDATE_STATEMENT = 'UPDATE_STATEMENT'
const UPDATE_IS_SHOW_CHECK_CODE = 'UPDATE_IS_SHOW_CHECK_CODE'
const UPDATE_CHANGE_SHOW = 'UPDATE_CHANGE_SHOW'
const UPDATE_COMPANT_LIST = 'UPDATE_COMPANT_LIST'
const UPDATE_CUSTOMER_COMPANT_LIST = 'UPDATE_CUSTOMER_COMPANT_LIST'
const UPDATE_RENDER_BREADCRUMB = 'UPDATE_RENDER_BREADCRUMB'
const UPDATE_CUSTOMER_COMPANT_DATA = 'UPDATE_CUSTOMER_COMPANT_DATA'
const UPDATE_IS_SHOW_APPLY = 'UPDATE_IS_SHOW_APPLY'
const UPDATE_REQ_PERMISSION_CODE = 'UPDATE_REQ_PERMISSION_CODE'

const authList = sessionStorage.getItem('authList')
  ? JSON.parse(sessionStorage.getItem('authList')) : {menu: [], button: [], page: []}
const menuList = sessionStorage.getItem('menuList')
  ? JSON.parse(sessionStorage.getItem('menuList')) : []
const userInfo = sessionStorage.getItem('userInfo')
  ? JSON.parse(sessionStorage.getItem('userInfo')) : {}

const state = {
  token: getToken(),
  menuList: menuList,
  authList: authList,
  userInfo: userInfo,
  statement: {},
  isShowCheckCode: false, // 控制显示防爬输入验证码弹窗
  changeShow: false,
  companyList: [],
  customerCompanyList: [],
  renderBreadcrumb: true,
  customerCompanyData: [],
  isShowApply: false,
  reqPermissionCode: ''
}

const getters = {
  token: state => state.token,
  authList: state => state.authList,
  btnList: state => state.authList.button,
  pageList: state => state.authList.page,
  menuList: state => state.menuList,
  // menuList: state => menu,
  userInfo: state => state.userInfo,
  statement: state => state.statement,
  isShowCheckCode: state => state.isShowCheckCode,
  changeShow: state => state.changeShow,
  companyList: state => state.companyList.map(v => {
    return {
      ...v,
      value: v.name
    }
  }),
  customerCompanyList: state => state.customerCompanyList.map(v => {
    return {
      value: v,
      label: v
    }
  }),
  renderBreadcrumb: state => state.renderBreadcrumb,
  customerCompanyData: state => state.customerCompanyData,
  isShowApply: state => state.isShowApply,
  reqPermissionCode: state => state.reqPermissionCode
}

const mutations = {
  [SET_TOKEN] (state, token) {
    state.token = token
  },
  [SET_MENU] (state, menuList) {
    state.menuList = menuList
  },
  [SET_AUTH] (state, authList) {
    state.authList = authList
  },
  [SET_USER_INFO] (state, userInfo) {
    state.userInfo = userInfo
    // 埋点
    Track.setTrackParam({
      uid: userInfo.id,
      account: userInfo.account,
      ip: userInfo.ip
    })
  },
  [UPDATE_STATEMENT] (state, statement) {
    state.statement = statement
  },
  [UPDATE_IS_SHOW_CHECK_CODE] (state, statement) {
    state.isShowCheckCode = statement
  },
  [UPDATE_CHANGE_SHOW] (state, changeShow) {
    state.changeShow = changeShow
  },
  [UPDATE_COMPANT_LIST] (state, companyList) {
    state.companyList = companyList
  },
  [UPDATE_CUSTOMER_COMPANT_LIST] (state, customerCompanyList) {
    state.customerCompanyList = customerCompanyList
  },
  [UPDATE_RENDER_BREADCRUMB] (state, renderBreadcrumb) {
    state.renderBreadcrumb = renderBreadcrumb
  },
  [UPDATE_CUSTOMER_COMPANT_DATA] (state, customerCompanyData) {
    state.customerCompanyData = customerCompanyData
  },
  [UPDATE_IS_SHOW_APPLY] (state, isShowApply) {
    state.isShowApply = isShowApply
  },
  [UPDATE_REQ_PERMISSION_CODE] (state, reqPermissionCode) {
    state.reqPermissionCode = reqPermissionCode
  }
}

const actions = {
  // 登录
  async loginApi ({dispatch, commit}, params) {
    const { account, password } = { ...params }
    try {
      const { data: res } = await login({ account, password })
      if (res.errorCode !== 20011) {
        sessionStorage.setItem('userInfo', JSON.stringify(res))
        sessionStorage.setItem('headImage', res.headImage)
        commit(SET_USER_INFO, res)
        commit(SET_TOKEN, res.loginCode)
        setToken(res.loginCode)
        await Promise.all([
          dispatch('getMenuApi'),
          dispatch('getPermissionApi')
        ])
      }
      return res
    } catch (e) {
      if (e.data && e.data.loginCode) setToken(e.data.loginCode)
      return e
    }
  },
  // 获取菜单列表
  async getMenuApi ({state, commit}) {
    if (!state.token) return
    try {
      const { data: res } = await getMenu()
      commit(SET_MENU, res)
      sessionStorage.setItem('menuList', JSON.stringify(res))
    } catch (e) {}
  },
  // remove token
  resetTokenApi ({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      removeToken()
      resolve()
    })
  },
  // 登出
  async logoutApi ({ commit, state }) {
    try {
      await logout(state.token)
      commit('SET_TOKEN', '')
      removeToken()
      commit('SET_USER_INFO', {})
      sessionStorage.removeItem('userInfo')
      commit('SET_AUTH', {menu: [], button: [], page: []})
      sessionStorage.removeItem('authList')
      commit('SET_MENU', [])
      sessionStorage.removeItem('menuList')
    } catch (e) {
      Message.error(e)
    }
  },
  // 修改密码
  async updatePasswordApi ({ commit }, params) {
    try {
      const data = {
        oldPassword: params.password,
        newPassword: params.newPassword,
        code: params.code
      }
      const res = await updatePassword(data)
      Message.success('success')
      return res
    } catch (e) {}
  },
  // 修改密码
  async publicUpdatePasswordApi ({ commit }, params) {
    try {
      const data = {
        oldPassword: params.password,
        password: params.newPassword,
        code: params.code,
        account: params.account
      }
      const res = await publicUpdatePassword(data)
      Message.success('success')
      return res
    } catch (e) {}
  },
  // 修改头像
  async updateHeadImgApi ({ commit }, { id, fileSrc }) {
    try {
      const data = {
        fileId: id,
        fileImage: fileSrc
      }
      await updateHeadImg(data)
      Message.success('success')
      return true
    } catch (e) {
      return false
    }
  },
  // 切换语言
  async changeLanguageApi ({ commit }, params) {
    try {
      const data = { languageId: params }
      await changeLanguage(data)
      return true
    } catch (e) {
      return false
    }
  },
  // 获取用户信息
  async getUserInfoApi ({ commit }) {
    try {
      const { data: res } = await getUserInfo()
      sessionStorage.setItem('userInfo', JSON.stringify(res))
      sessionStorage.setItem('headImage', res.headImage)
      commit(SET_USER_INFO, res)
      return true
    } catch (e) {
      return false
    }
  },
  // 获取权限列表
  async getPermissionApi ({ commit }) {
    try {
      const { data: res } = await getPermisson()
      commit(SET_AUTH, res)
      sessionStorage.setItem('authList', JSON.stringify(res))
      return true
    } catch (e) {
      return false
    }
  },
  // 获取隐私条款
  async getStatementApi ({ commit }) {
    try {
      const { data: res } = await getStatement()
      commit(UPDATE_STATEMENT, res)
    } catch (e) {}
  },
  // 发送邮件
  async sendEmailApi ({ commit }, params) {
    try {
      await sendEmail(params)
      return true
    } catch (e) {
      return false
    }
  },
  // 忘记密码提交
  async forgetPasswordApi ({ commit }, params) {
    try {
      await forgetPassword(params)
      return true
    } catch (e) {
      return false
    }
  },
  async sendMessageApi ({ commit }, params) {
    try {
      const res = await sendMessage(params)
      return res
    } catch (e) {
      return false
    }
  },
  async checkPassApi ({ commit }, params) {
    try {
      await checkPass(params)
      return true
    } catch (e) {
      return false
    }
  },
  // 修改密码发送验证码
  async sendEmailForChangePwdApi ({ commit }, params) {
    try {
      await sendEmailForChangePwd(params)
      return true
    } catch (e) {
      return false
    }
  },
  // 修改密码发送验证码
  async publicSendEmailForChangePwdApi ({ commit }, params) {
    try {
      await publicSendEmailForChangePwd(params)
      return true
    } catch (e) {
      return false
    }
  },
  // 修改密码发送验证码
  async getCheckCodeApi ({ commit }, params) {
    try {
      const res = await getCheckCode(params)
      return res
    } catch (e) {
      return false
    }
  },
  // 提交防爬验证码
  async submitChckeCodeApi ({ commit }, params) {
    try {
      const res = await submitChckeCode(params)
      return res
    } catch (e) {
      return false
    }
  },
  // 增加扫描次数
  async incrScannedTimesApi ({ commit }, params) {
    try {
      await incrScannedTimes(params)
    } catch (e) {}
  },
  // 用户注册-发送验证码
  async getRegisterCodeApi ({ commit }, params) {
    try {
      const res = await getRegisterCode(params)
      return res
    } catch (e) {}
  },
  // 用户注册
  async registerApi ({ commit }, params) {
    try {
      const res = await register(params)
      return res
    } catch (e) {}
  },
  // 获取company
  async getCompanyListApi ({state, commit}, params) {
    try {
      const { data: res } = await getCompanyList(params)
      commit(UPDATE_COMPANT_LIST, res || [])
    } catch (e) {}
  },
  // 获取company
  async getCustomerCompanyListApi ({state, commit}, params) {
    try {
      const { data: res } = await getCustomerCompanyList(params)
      commit(UPDATE_CUSTOMER_COMPANT_LIST, res || [])
    } catch (e) {}
  },
  async updateSessionApi ({state, commit}, params) {
    try {
      const res = await updateSession(params)
      return res
    } catch (e) {
      return false
    }
  },
  async checkAccountApi ({state, commit}, params) {
    try {
      const res = await checkAccount(params)
      return res
    } catch (e) {
      return false
    }
  },
  async activateApi ({state, commit}, params) {
    try {
      const res = await activate(params)
      return res
    } catch (e) {
      return false
    }
  },
  async reActivateApi ({state, commit}, params) {
    try {
      const res = await reActivate(params)
      return res
    } catch (e) {
      return false
    }
  },
  async updateUserInfoApi ({state, commit}, params) {
    try {
      const res = await updateUserInfo(params)
      return res
    } catch (e) {
      return false
    }
  },
  async getDegretionInfoApi ({state, commit}, params) {
    try {
      const {data: res} = await getDegretionInfo(params)
      return res
    } catch (e) {
      return false
    }
  },
  async writtenOffApi ({state, commit}, params) {
    try {
      const {data: res} = await writtenOff(params)
      return res
    } catch (e) {
      return false
    }
  },
  async checkPasswordApi ({state, commit}, params) {
    try {
      const res = await checkPassword(params)
      return res
    } catch (e) {
      return false
    }
  },
  async publicCheckPasswordApi ({state, commit}, params) {
    try {
      const res = await publicCheckPassword(params)
      return res
    } catch (e) {
      return false
    }
  },
  async checkNewPasswordApi ({state, commit}, params) {
    try {
      const res = await checkNewPassword(params)
      return res
    } catch (e) {
      return false
    }
  },
  // 获取company
  async getCustomerCompanyDataApi ({state, commit}, params) {
    try {
      const { data: res } = await getCustomerCompanyData(params)
      commit(UPDATE_CUSTOMER_COMPANT_DATA, res || [])
      console.log(res)
      return res
    } catch (e) {}
  },
  async setIsShowApply ({state, commit, dispatch}, params) {
    let value = params.value ? params.value : params
    let reqPermissionCode = params.reqPermissionCode || ''
    commit(UPDATE_REQ_PERMISSION_CODE, reqPermissionCode)
    if (value) {
      await dispatch('getUserInfoApi')
      commit(UPDATE_IS_SHOW_APPLY, value)
    } else {
      commit(UPDATE_IS_SHOW_APPLY, value)
    }
  },
  async unlockEmailWhetherSentApi ({state, commit}, params) {
    try {
      const { data: res } = await unlockEmailWhetherSent(params)
      return res
    } catch (e) {
      return false
    }
  }
}

// sendEmail

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/login.js